/**
 * @const SET_SECURITY
d */
export const SET_SECURITY = "Login.SetSecurity";
